import { DayPeriodEnum } from '@enums/dayPeriod.enum';

export const defaultTimeParts = {
  hours: '--',
  minutes: '--',
  dayPeriod: DayPeriodEnum.AM,
};
